<template>
  <div v-if="value" class="modal-wrap">
    <div class="modal-conent">
      <slot :closeModal="closeModal"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  methods: {
    closeModal() {
      this.$emit('input', false);
    },
    disableBodyScroll() {
      document.body.classList.add('overflow-hidden');
    },
    enableBodyScroll() {
      document.body.classList.remove('overflow-hidden');
    },
  },
  beforeDestroy() {
    this.enableBodyScroll();
  },
  mounted() {
    window.closeModal = this.closeModal;
  },
  watch: {
    value(val) {
      if (val) {
        this.disableBodyScroll();
      } else {
        this.enableBodyScroll();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999999;
  background: #00000022;

  .modal-conent {
    background: #fff;
    padding: 15px 25px;
  }
}

@media screen and (max-width: 778px) {
  .modal-conent {
    width: 100%;
  }
}
</style>
